module.exports = __webpack_public_path__ + "public/img/xiangjiao_logo.81d76aa3.png";